module.exports = __webpack_public_path__ + "img/jame.11357640.png";